module.exports = __webpack_public_path__ + "img/cloud-moon-solid.74d30893.svg";